
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import { Task } from '@/types';

@Component
export default class LeadRemoveDialog extends Vue {
  @Prop(Boolean) readonly value!: boolean;
  @Prop(Array) readonly childTasks: Task[] | null | undefined;

  dialog = false
  loading = false

  @Watch('value')
  onValueChange(val: boolean) {
    console.log('LeadRemoveDialog: onValueChange()'); // eslint-disable-line no-console

    this.dialog = val;
  }

  @Watch('dialog')
  onDialogChange(val: boolean) {
    if (this.value !== val) {
      this.$emit('input', val);
    }
  }

  get lead() {
    return this.$store.getters.currentLead;
  }

  get childCount() {
    return this.childTasks && 0 in this.childTasks && this.childTasks[0].childCount
      ? this.childTasks[0].childCount : 1;
  }

  async onCancel() {
    console.log('LeadRemoveDialog: onCancel()'); // eslint-disable-line no-console

    this.dialog = false;
  }

  async onRemove() {
    console.log('LeadRemoveDialog: onRemove()'); // eslint-disable-line no-console

    this.loading = true;

    await this.$store.dispatch('removeUnassignedChild', { childCount: this.childCount });

    this.dialog = false;
    setTimeout(() => {
      this.loading = false;
    }, 500);
  }
}
